import { LoadMoreButton } from "@rio-cloud/rio-uikit";

export type ConfigPaginator = {
  next: number;
  total: number
}

interface Props {
  size: number;
  totalSize: number;
  hiddenReset?: boolean;
  isLoading?: boolean;
  handleReset: () => void;
  handleLoadMore: (config: ConfigPaginator) => void;
}

const PaginatorSize = ({
  size = 10,
  totalSize,
  hiddenReset = true,
  isLoading = false,
  handleReset,
  handleLoadMore
}: Props) => {

  const handleMore = () => {
    handleLoadMore({
      next: size + 10,
      total: totalSize,
    })
  }

  return (
    <div className={`display-flex justify-content-center align-items-center width-100pct`} >
      <LoadMoreButton loaded={size > totalSize ? totalSize : size } total={totalSize}
        loadMoreMessage={
          <div className='display-flex flex-row gap-10'>
            {!hiddenReset ? (
              <button className='btn btn-default' type='button' onClick={handleReset}>
                Resetar
              </button>
            ) : null}
            <button className='btn btn-default btn-primary' type='button' onClick={handleMore} disabled={isLoading}>
              {isLoading ? 'Carregando...' : 'Carregar mais'}
            </button>
          </div>
        }
        noMoreMessage={
          <div className='display-flex flex-column justify-content-center align-items-center'>
            {!hiddenReset ? (
              <div className='flex flex-row align-items-center justify-content-center margin-bottom-10'>
                <button className='btn btn-default flex-row' type='button' onClick={handleReset}>
                  Resetar
                </button>
              </div>
            ) : null}
            <div className='flex flex-row'>
              <span>Não há mais resultados</span>
            </div>
          </div>
        }
        progressBarStyle='gray'
        isInteractive={false}
      />
    </div>
  );
};

export default PaginatorSize;
